import{e as o,m as i}from"./chunk-HBP5N4FR.js";var x,l=o(()=>{i();x=({data:n,highlight:t,occurrences:s,transactionIndex:r})=>{let e=s[r]||n.indexOf(t),c=t.length,g=n.slice(0,e),h=n.slice(e+c);return{start:g,end:h}}});export{x as a,l as b};
//# sourceMappingURL=chunk-AAI7OAOT.js.map
